export const fluent = (fn, def) => {
  try {
    return fn()
  } catch (e) {
    if (e instanceof TypeError) {
      return def
    }
    throw e
  }
}

export const rules = {
  required: () => ({ required: true, trigger: 'blur' })
}



export const isNull = v => v === undefined || v === null

export const dev = process.env.NODE_ENV === 'development'

export const removePropIfNull = (props) => {
  if (props instanceof FormData) {
    const ret = new FormData()
    for (let [k, v] of props) {
      if (isNull(v)) { continue }
      ret.append(k, v)
    }
    return ret
  }

  const ret = {}
  for (let [k, v] of Object.entries(props)) {
    if (isNull(v)) { continue }
    ret[k] = v
  }

  return ret
}


export const pageFilter = (list, { page, size }) => {
  const start = page * size
  const end = start + size
  return list.slice(start, end)
}


export const routerQuery = (name) => (v) =>{
  const route = Vue.router.currentRoute
  let query = { ...route.query }
  if (isNull(v)) {
    delete query[name]
  } else {
    query[name] = v
  }
  Vue.router.push({
    ...route,
    query
  })
}


export const mapCompute = (map, initialValue, key, compute) => {
  let value
  if (map.has(key)) {
    value = map.get(key)
  } else {
    value = typeof initialValue === 'function' ? initialValue(key) : initialValue
  }
  map.set(key, compute(value))
}

export const mapSetIfAbsent = (map, initialValue, key) => {
  if (map.has(key)) {
    return map.get(key)
  }
  const value = typeof initialValue === 'function' ? initialValue(key) : initialValue
  map.set(key, value)
  return value
}





